import { SignupForm } from '@/components/auth/SignupForm';

export default function SignupPage() {
  return (
    <div className='bg-slate-50 dark:bg-stone-950 flex min-h-svh flex-col items-center justify-center p-6 md:p-10'>
      <div className='w-full max-w-sm md:max-w-3xl'>
        <SignupForm />
      </div>
    </div>
  );
}
